<template>
  <div>
    <div class="container-fluid bg-primary frontBanner">
      <div class="container">
        <transition appear name="fade" mode="out-in">
          <div class="row" v-if="this.authData" key="authorised">
          </div>
          <div class="row" v-else key="unauthorised">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
              <h2>Enter your details to login.</h2>
              <form v-on:submit.prevent="userLogin">
                <div class="form-group">
                  <input type="email" class="form-control input-lg" v-model="txtEmail" placeholder="Email" v-on:keydown.enter.prevent="focusNextField">
                </div>
                <div class="form-group">
                  <input type="password" class="form-control input-lg" v-model="txtPassword" placeholder="Password">
                </div>
                <button type="submit" class="btn btn-default btn-block btn-info btn-lg">Login</button>
              </form>
              <h3 class="text-center"><a v-on:click.prevent="userResetPassword">Forgotten your password?</a></h3>
              <div class="alert alert-danger" role="alert" v-if="messageError">{{ messageError }}</div>
              <div class="alert alert-success" role="alert" v-if="messageSuccess">{{ messageSuccess }}</div>
            </div>
            <div class="col-lg-2"></div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  // global variables
  var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  var blankUser = { name: null,
                    email: null,
                    type: null};
  import Vuex from 'vuex';
  import { mapState } from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase';

  var db = firebase.database();
  var firebaseAuth = firebase.auth();
  // end global variables


  // helper functions
  // end helper functions

  export default {
    name: "loginform",
    computed: {
      ...mapState({
        // map e.g. this.authData to store.state.authData
        authData: 'authData',
        currentUser: 'currentUser'
      })
    },
    data () {
      return {
        txtEmail: '',
        txtPassword: '',
        messageError: null,
        messageSuccess: null
      }
    },
    methods: {
      userLogin: function (evt) { // validates user details and signs in via firebase auth
        var self = this;
        var email = self.txtEmail;
        var password = self.txtPassword;
        self.messageError = null;
        self.messageSuccess = null;

        if (!regexEmail.test(email)) {
          self.messageError = 'Please enter a valid email address.';
          return;
        }
        if (password.length < 4) {
          self.messageError = 'Please enter a valid password.';
          return;
        }

        firebase.auth().signInWithEmailAndPassword(email, password).catch( function(error) {
          if (error.code === 'auth/wrong-password') {
            self.messageError = 'Incorrect username and/or password.';
          } else if (error.code === 'auth/user-not-found') {
            self.messageError = 'Incorrect username and/or password.';
          } else {
            self.messageError = error.message;
          }
        });
      },
      userResetPassword: function (evt) { // sends user email with link to reset password
        var email = this.txtEmail;

        firebase.auth().sendPasswordResetEmail(email).then( $.proxy(function() {
          this.messageError = '';
          this.messageSuccess = 'Password reset email sent to ' + email;
        }, this)).catch( $.proxy(function(error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode == 'auth/invalid-email') {
            this.messageError = "The above email address is not valid. Please confirm and try again.";
          } else if (errorCode == 'auth/user-not-found') {
            this.messageError = "The above email address cannot be found, please check that it has been entered correctly.";
          }
        }, this));
      },
      focusNextField: function (event) { // moves focus to next input field
        $(event.target).parent().next("div").find("input").focus();
      }
    },
    components: {
    }
  }
</script>



/** WEBPACK FOOTER **
 ** loginform.vue?63ebc3b9
 **/